import { bulkImportPuzzles, deleteAllPuzzles, ChessPuzzle } from '../services/chessPuzzleService';
import { toast } from 'react-toastify';
// import { generateUniquePuzzlesFromGames } from './generateUniquePuzzles';
// import { UNIQUE_PUZZLE_DATABASE } from '../data/uniquePuzzleDatabase';
// import { getAllSamplePuzzles } from '../data/sampleChessPuzzles';
// import { LICHESS_PUZZLES } from '../data/lichessPuzzles'; // OLD: Not validated
// import { VALIDATED_LICHESS_PUZZLES } from '../data/validatedLichessPuzzles'; // Good, but not premium
// import { PREMIUM_QUALITY_PUZZLES } from '../data/premiumQualityPuzzles'; // 595 puzzles
// import { ELITE_300_PUZZLES } from '../data/elite300Puzzles'; // Had material loss issues
import { PERFECT_300_PUZZLES } from '../data/perfect300Puzzles'; // ✅ 300 endgame/middlegame
import { ADDITIONAL_500_PUZZLES } from '../data/additional500Puzzles'; // ✅ 425 tactics/strategy/opening

/**
 * Generate completely diverse puzzles using proven unique puzzle generators
 * Combines multiple sources to ensure maximum diversity
 */
function generateDiversePuzzleSet(
    count: number,
    category: 'tactics' | 'opening' | 'endgame' | 'middlegame' | 'strategy' | 'calculation' | 'pattern' | 'checkmate' | 'defense',
    minRating: number = 1000,
    maxRating: number = 2500
): Omit<ChessPuzzle, 'id' | 'createdAt' | 'createdBy'>[] {
    const allPuzzles: Omit<ChessPuzzle, 'id' | 'createdAt' | 'createdBy'>[] = [];
    const seenFens = new Set<string>();
    
    console.log(`🎲 Generating ${count} completely diverse ${category} puzzles from multiple sources...`);
    
    // SOURCE 0: CHECKMATE_PATTERN_PUZZLES - REMOVED
    // The handcrafted patterns had validation errors (not real checkmate)
    // Using only verified Lichess puzzles instead
    
    // SOURCE 1: PERFECT_300_PUZZLES (300 PERFECT puzzles - Popularity > 95, Material validated!)
    // These are PERFECT puzzles: No material loss, correct colors, fully validated
    if (PERFECT_300_PUZZLES && PERFECT_300_PUZZLES.length > 0) {
        // Filter by category and rating range, then distribute by difficulty
        const categoryPuzzles = PERFECT_300_PUZZLES
            .filter(p => p.category === category && p.rating >= minRating && p.rating <= maxRating);
        
        // Distribute evenly across difficulty levels
        const beginnerPuzzles = categoryPuzzles.filter(p => p.rating < 1300);
        const intermediatePuzzles = categoryPuzzles.filter(p => p.rating >= 1300 && p.rating < 1800);
        const advancedPuzzles = categoryPuzzles.filter(p => p.rating >= 1800);
        
        // Take equal amounts from each difficulty level for balanced distribution
        const targetPerDifficulty = Math.floor(count / 3);
        const selectedPuzzles = [
            ...beginnerPuzzles.slice(0, targetPerDifficulty),
            ...intermediatePuzzles.slice(0, targetPerDifficulty),
            ...advancedPuzzles.slice(0, targetPerDifficulty)
        ].sort(() => Math.random() - 0.5); // Shuffle for variety
        
        const lichessPuzzles = selectedPuzzles.map(p => ({
            fen: p.fen,
            moves: p.moves,
            rating: p.rating,
            themes: p.themes,
            description: p.description,
            hint: p.hint,
            complexity: (p.rating < 1300 ? 'beginner' : p.rating < 1800 ? 'intermediate' : 'advanced') as 'beginner' | 'intermediate' | 'advanced',
            category: p.category,
            source: 'lichess' as const
        }));
        
        console.log(`🎯 Found ${lichessPuzzles.length} puzzles from LICHESS database for ${category}`);
        
        // Add Lichess puzzles (shuffle for variety)
        const shuffledLichess = lichessPuzzles.sort(() => Math.random() - 0.5);
        for (const puzzle of shuffledLichess) {
            if (allPuzzles.length >= count) break;
            if (!seenFens.has(puzzle.fen)) {
                allPuzzles.push(puzzle);
                seenFens.add(puzzle.fen);
            }
        }
    }
    
    // // SOURCE 2: UNIQUE_PUZZLE_DATABASE (filtered by category)
    // const uniqueDbPuzzles = UNIQUE_PUZZLE_DATABASE
    //     .filter(p => p.category === category && p.rating >= minRating && p.rating <= maxRating)
    //     .map(p => ({
    //         fen: p.fen,
    //         moves: p.moves,
    //         rating: p.rating,
    //         themes: p.themes,
    //         description: p.description,
    //         hint: p.hint,
    //         complexity: p.rating < 1300 ? 'beginner' : p.rating < 1800 ? 'intermediate' : 'advanced',
    //         category: p.category,
    //         source: 'local' as const
    //     }));
    
    // console.log(`📚 Found ${uniqueDbPuzzles.length} puzzles from UNIQUE_PUZZLE_DATABASE for ${category}`);
    
    // // Add unique DB puzzles
    // for (const puzzle of uniqueDbPuzzles) {
    //     if (allPuzzles.length >= count) break;
    //     if (!seenFens.has(puzzle.fen)) {
    //         allPuzzles.push(puzzle);
    //         seenFens.add(puzzle.fen);
    //     }
    // }
    
    // // SOURCE 3: Generate from game sequences (proven to create unique FENs)
    // const needed = Math.max(0, count - allPuzzles.length);
    // if (needed > 0) {
    //     console.log(`🎮 Generating ${needed} more puzzles from game sequences...`);
    //     const generatedPuzzles = generateUniquePuzzlesFromGames(needed * 2, category, minRating, maxRating);
        
    //     for (const puzzle of generatedPuzzles) {
    //         if (allPuzzles.length >= count) break;
    //         if (!seenFens.has(puzzle.fen)) {
    //             allPuzzles.push({
    //                 fen: puzzle.fen,
    //                 moves: puzzle.moves,
    //                 rating: puzzle.rating,
    //                 themes: puzzle.themes,
    //                 description: puzzle.description,
    //                 hint: puzzle.hint,
    //                 complexity: puzzle.rating < 1300 ? 'beginner' : puzzle.rating < 1800 ? 'intermediate' : 'advanced',
    //                 category: puzzle.category,
    //                 source: 'local' as const
    //             });
    //             seenFens.add(puzzle.fen);
    //         }
    //     }
    //     console.log(`✅ Generated ${allPuzzles.length - uniqueDbPuzzles.length} unique puzzles from game sequences`);
    // }
    
    // // SOURCE 4: Sample puzzles (filtered by category)
    // if (allPuzzles.length < count) {
    //     const samplePuzzles = getAllSamplePuzzles()
    //         .filter(p => p.category === category && p.rating >= minRating && p.rating <= maxRating)
    //         .map(p => ({
    //             fen: p.fen,
    //             moves: p.moves,
    //             rating: p.rating,
    //             themes: p.themes,
    //             description: p.description || `${category} puzzle`,
    //             hint: p.hint || `Find the best move in this ${category} position`,
    //             complexity: p.rating < 1300 ? 'beginner' : p.rating < 1800 ? 'intermediate' : 'advanced',
    //             category: p.category as typeof category,
    //             source: 'local' as const
    //         }));
        
    //     for (const puzzle of samplePuzzles) {
    //         if (allPuzzles.length >= count) break;
    //         if (!seenFens.has(puzzle.fen)) {
    //             allPuzzles.push(puzzle);
    //             seenFens.add(puzzle.fen);
    //         }
    //     }
    //     console.log(`📖 Added ${samplePuzzles.filter(sp => allPuzzles.some(ap => ap.fen === sp.fen)).length} sample puzzles`);
    // }
    
    // // SOURCE 5: If still not enough, generate more from sequences with different parameters
    // if (allPuzzles.length < count) {
    //     const stillNeeded = count - allPuzzles.length;
    //     console.log(`🔄 Generating ${stillNeeded} more puzzles with different game sequences...`);
        
    //     // Generate with different rating ranges to get more variety
    //     const additionalPuzzles = generateUniquePuzzlesFromGames(
    //         stillNeeded * 3, 
    //         category, 
    //         Math.max(800, minRating - 200), 
    //         Math.min(2800, maxRating + 200)
    //     );
        
    //     for (const puzzle of additionalPuzzles) {
    //         if (allPuzzles.length >= count) break;
    //         if (!seenFens.has(puzzle.fen)) {
    //             // Adjust rating to fit within bounds
    //             const adjustedRating = Math.max(minRating, Math.min(maxRating, puzzle.rating));
    //             allPuzzles.push({
    //                 fen: puzzle.fen,
    //                 moves: puzzle.moves,
    //                 rating: adjustedRating,
    //                 themes: puzzle.themes,
    //                 description: puzzle.description,
    //                 hint: puzzle.hint,
    //                 complexity: adjustedRating < 1300 ? 'beginner' : adjustedRating < 1800 ? 'intermediate' : 'advanced',
    //                 category: puzzle.category,
    //                 source: 'local' as const
    //             });
    //             seenFens.add(puzzle.fen);
    //         }
    //     }
    // }
    
    // Shuffle to ensure variety in order
    const shuffled = allPuzzles.sort(() => Math.random() - 0.5);
    
    console.log(`✅ Generated ${shuffled.length} diverse ${category} puzzles (${seenFens.size} unique FENs)`);
    return shuffled.slice(0, count);
}

/**
 * Seed puzzles to Firestore for a service provider
 * Uses proven unique puzzle generation methods
 */
export const seedPuzzlesToDatabase = async (
    serviceProviderId: string,
    userId: string,
    onProgress?: (current: number, total: number) => void,
    deleteExisting: boolean = true
): Promise<{ success: boolean; count: number }> => {
    try {
        console.log('🌱 Starting puzzle seeding with PROVEN unique puzzle generators...');
        
        // ALWAYS delete old puzzles first to ensure clean slate
        if (deleteExisting) {
            console.log('🗑️ Deleting ALL old puzzles...');
            toast.info('Deleting old puzzles...');
            try {
                const deletedCount = await deleteAllPuzzles(serviceProviderId);
                console.log(`✅ Deleted ${deletedCount} old puzzles`);
                toast.success(`✅ Deleted ${deletedCount} old puzzles`);
                
                // Wait a moment for Firestore to process deletes
                await new Promise(resolve => setTimeout(resolve, 1000));
            } catch (error) {
                console.error('⚠️ Error deleting old puzzles:', error);
                toast.error('Error deleting old puzzles');
                throw error;
            }
        }
        
        // Combine PERFECT_300_PUZZLES + ADDITIONAL_500_PUZZLES = 725 total!
        console.log('🏆 Seeding HIGH-QUALITY puzzles...');
        console.log(`📥 Source 1: ${PERFECT_300_PUZZLES.length} puzzles (Endgame/Middlegame/Opening)`);
        console.log(`📥 Source 2: ${ADDITIONAL_500_PUZZLES.length} puzzles (Tactics/Strategy/Opening)`);
        console.log(`📥 Total: ${PERFECT_300_PUZZLES.length + ADDITIONAL_500_PUZZLES.length} PERFECT puzzles`);
        
        // Combine both sources
        const allPuzzles: Omit<ChessPuzzle, 'id' | 'createdAt' | 'createdBy'>[] = [
            ...PERFECT_300_PUZZLES.map(p => ({
                fen: p.fen,
                moves: p.moves,
                rating: p.rating,
                themes: p.themes,
                description: p.description,
                hint: p.hint,
                complexity: p.complexity,
                category: p.category,
                source: 'lichess' as const
            })),
            ...ADDITIONAL_500_PUZZLES.map(p => ({
                fen: p.fen,
                moves: p.moves,
                rating: p.rating,
                themes: p.themes,
                description: p.description,
                hint: p.hint,
                complexity: p.complexity,
                category: p.category,
                source: 'lichess' as const
            }))
        ];
        
        console.log(`\n📦 Total puzzles to seed: ${allPuzzles.length}`);
        console.log(`   ✅ Tactics: ${allPuzzles.filter(p => p.category === 'tactics').length}`);
        console.log(`   ✅ Strategy: ${allPuzzles.filter(p => p.category === 'strategy').length}`);
        console.log(`   ✅ Endgame: ${allPuzzles.filter(p => p.category === 'endgame').length}`);
        console.log(`   ✅ Middlegame: ${allPuzzles.filter(p => p.category === 'middlegame').length}`);
        console.log(`   ✅ Opening: ${allPuzzles.filter(p => p.category === 'opening').length}`);
        console.log(`   ✅ Checkmate: ${allPuzzles.filter(p => p.category === 'checkmate').length}`);
        
        // Verify expected count (300 + 425 = 725)
        const expectedCountActual = PERFECT_300_PUZZLES.length + ADDITIONAL_500_PUZZLES.length;
        if (allPuzzles.length !== expectedCountActual) {
            console.error(`🚨 ERROR: Expected ${expectedCountActual} puzzles but got ${allPuzzles.length}!`);
            throw new Error(`Puzzle count mismatch: expected ${expectedCountActual}, got ${allPuzzles.length}`);
        }
        
        // Report total count
        if (onProgress) {
            onProgress(0, allPuzzles.length);   
        }
        
        // Import to Firestore with progress tracking
        let importedCount = 0;
        const batchSize = 50;
        
        for (let i = 0; i < allPuzzles.length; i += batchSize) {
            const batch = allPuzzles.slice(i, i + batchSize);
            const count = await bulkImportPuzzles(
                serviceProviderId,
                batch,
                userId
            );
            importedCount += count;
            
            // Report progress
            if (onProgress) {
                onProgress(Math.min(i + batchSize, allPuzzles.length), allPuzzles.length);
            }
        }
        
        console.log(`\n📊 FINAL IMPORT RESULTS:`);
        console.log(`   • Attempted to import: ${allPuzzles.length} puzzles`);
        console.log(`   • Actually imported: ${importedCount} puzzles`);
        console.log(`   • Duplicates/Skipped: ${allPuzzles.length - importedCount} puzzles`);
        
        const expectedCount = allPuzzles.length;
        if (importedCount === expectedCount) {
            toast.success(`🎉 Successfully imported ALL ${importedCount} PERFECT puzzles!`);
            console.log(`✅ Successfully imported ${importedCount} puzzles`);
        } else if (importedCount > 0) {
            toast.warning(`⚠️ Imported ${importedCount} puzzles (expected ${expectedCount})`);
            console.warn(`⚠️ Import count mismatch: ${importedCount} vs expected ${expectedCount}`);
        } else {
            toast.error('❌ No puzzles were imported!');
            console.error('❌ No puzzles were imported');
        }
        
        return {
            success: importedCount > 0,
            count: importedCount
        };
    } catch (error) {
        console.error('❌ Error seeding puzzles:', error);
        toast.error('Failed to seed puzzles to database');
        return {
            success: false,
            count: 0
        };
    }
};

/**
 * Parse CSV content from top_3000_curated_puzzles.csv
 * CSV format: PuzzleId,FEN,Moves,Rating,complexity,game_state,Themes
 */
const parseAdvancedPuzzlesCSV = (csvContent: string): Omit<ChessPuzzle, 'id' | 'createdAt' | 'createdBy'>[] => {
    const lines = csvContent.split('\n').filter(line => line.trim());
    const puzzles: Omit<ChessPuzzle, 'id' | 'createdAt' | 'createdBy'>[] = [];
    
    // Skip header row
    for (let i = 1; i < lines.length; i++) {
        try {
            const line = lines[i];
            // Handle CSV parsing - split by comma but respect quoted fields
            const parts: string[] = [];
            let currentPart = '';
            let inQuotes = false;
            
            for (let j = 0; j < line.length; j++) {
                const char = line[j];
                if (char === '"') {
                    inQuotes = !inQuotes;
                } else if (char === ',' && !inQuotes) {
                    parts.push(currentPart.trim());
                    currentPart = '';
                } else {
                    currentPart += char;
                }
            }
            parts.push(currentPart.trim()); // Add last part
            
            if (parts.length < 7) continue;
            
            const puzzleId = parts[0];
            const fen = parts[1];
            const moves = parts[2].replace(/\s+/g, ' ').trim();
            const rating = parseInt(parts[3]) || 1500;
            const complexityRaw = parts[4]?.toLowerCase() || 'intermediate';
            // Map "expert" to "advanced" to match the interface
            const complexity = (complexityRaw === 'expert' ? 'advanced' : complexityRaw) as 'beginner' | 'intermediate' | 'advanced';
            const gameState = parts[5]?.toLowerCase() || 'middlegame';
            const themesStr = parts[6] || '';
            const themes = themesStr.split(' ').filter(t => t.trim()).map(t => t.trim());
            
            // Map game_state to category
            let category: ChessPuzzle['category'] = 'tactics';
            if (gameState.includes('endgame')) {
                category = 'endgame';
            } else if (gameState.includes('opening')) {
                category = 'opening';
            } else if (gameState.includes('middlegame')) {
                category = 'middlegame';
            } else if (gameState.includes('checkmate') || themes.some(t => t.toLowerCase().includes('mate'))) {
                category = 'checkmate';
            } else if (themes.some(t => ['strategy', 'positional'].includes(t.toLowerCase()))) {
                category = 'strategy';
            } else if (themes.some(t => ['calculation', 'long'].includes(t.toLowerCase()))) {
                category = 'calculation';
            } else if (themes.some(t => ['pattern'].includes(t.toLowerCase()))) {
                category = 'pattern';
            } else if (themes.some(t => ['defense', 'defensive'].includes(t.toLowerCase()))) {
                category = 'defense';
            }
            
            puzzles.push({
                fen: fen,
                moves: moves,
                rating: rating,
                themes: themes,
                description: `Advanced Puzzle #${puzzleId}`,
                hint: themes.length > 0 ? `Themes: ${themes.slice(0, 3).join(', ')}` : `Find the best move in this ${category} position`,
                complexity: complexity,
                category: category,
                source: 'custom' as const,
                lichessId: puzzleId
            });
        } catch (error) {
            console.error(`Error parsing line ${i}:`, error);
        }
    }
    
    return puzzles;
};

/**
 * Seed advanced puzzles from CSV file to Firestore for a service provider
 * Reads from /Users/adityak/puzzles/top_3000_curated_puzzles.csv
 */
export const seedAdvancedPuzzlesFromCSV = async (
    serviceProviderId: string,
    userId: string,
    csvFilePath: string = '/Users/adityak/puzzles/top_3000_curated_puzzles.csv',
    onProgress?: (current: number, total: number) => void,
    deleteExisting: boolean = false
): Promise<{ success: boolean; count: number }> => {
    try {
        console.log('🌱 Starting advanced puzzle seeding from CSV...');
        
        // Read CSV file (Node.js environment)
        let csvContent: string;
        try {
            // Try to use Node.js fs module if available
            if (typeof require !== 'undefined') {
                const fs = require('fs');
                csvContent = fs.readFileSync(csvFilePath, 'utf-8');
            } else {
                throw new Error('File system access not available. Please use seedAdvancedPuzzlesFromCSVContent instead.');
            }
        } catch (error) {
            console.error('❌ Error reading CSV file:', error);
            toast.error('Failed to read CSV file. Make sure the file path is correct.');
            return {
                success: false,
                count: 0
            };
        }
        
        return await seedAdvancedPuzzlesFromCSVContent(
            serviceProviderId,
            userId,
            csvContent,
            onProgress,
            deleteExisting
        );
    } catch (error) {
        console.error('❌ Error seeding advanced puzzles:', error);
        toast.error('Failed to seed advanced puzzles to database');
        return {
            success: false,
            count: 0
        };
    }
};

/**
 * Seed advanced puzzles from CSV content string
 * This version can be used in browser environment with file upload
 */
export const seedAdvancedPuzzlesFromCSVContent = async (
    serviceProviderId: string,
    userId: string,
    csvContent: string,
    onProgress?: (current: number, total: number) => void,
    deleteExisting: boolean = false
): Promise<{ success: boolean; count: number }> => {
    try {
        console.log('🌱 Starting advanced puzzle seeding from CSV content...');
        
        // Delete existing puzzles if requested
        if (deleteExisting) {
            console.log('🗑️ Deleting ALL old puzzles...');
            toast.info('Deleting old puzzles...');
            try {
                const deletedCount = await deleteAllPuzzles(serviceProviderId);
                console.log(`✅ Deleted ${deletedCount} old puzzles`);
                toast.success(`✅ Deleted ${deletedCount} old puzzles`);
                
                // Wait a moment for Firestore to process deletes
                await new Promise(resolve => setTimeout(resolve, 1000));
            } catch (error) {
                console.error('⚠️ Error deleting old puzzles:', error);
                toast.error('Error deleting old puzzles');
                throw error;
            }
        }
        
        // Parse CSV content
        console.log('📊 Parsing CSV content...');
        const allPuzzles = parseAdvancedPuzzlesCSV(csvContent);
        
        console.log(`\n📦 Total puzzles to seed: ${allPuzzles.length}`);
        console.log(`   ✅ Tactics: ${allPuzzles.filter(p => p.category === 'tactics').length}`);
        console.log(`   ✅ Strategy: ${allPuzzles.filter(p => p.category === 'strategy').length}`);
        console.log(`   ✅ Endgame: ${allPuzzles.filter(p => p.category === 'endgame').length}`);
        console.log(`   ✅ Middlegame: ${allPuzzles.filter(p => p.category === 'middlegame').length}`);
        console.log(`   ✅ Opening: ${allPuzzles.filter(p => p.category === 'opening').length}`);
        console.log(`   ✅ Checkmate: ${allPuzzles.filter(p => p.category === 'checkmate').length}`);
        console.log(`   ✅ Calculation: ${allPuzzles.filter(p => p.category === 'calculation').length}`);
        console.log(`   ✅ Pattern: ${allPuzzles.filter(p => p.category === 'pattern').length}`);
        console.log(`   ✅ Defense: ${allPuzzles.filter(p => p.category === 'defense').length}`);
        
        // Report total count
        if (onProgress) {
            onProgress(0, allPuzzles.length);   
        }
        
        // Check puzzle limit (200 puzzles max per import)
        const MAX_PUZZLES = 200;
        if (allPuzzles.length > MAX_PUZZLES) {
            const errorMessage = `Too many puzzles! Maximum ${MAX_PUZZLES} puzzles allowed per import. Your file contains ${allPuzzles.length} puzzles. Please split your file into smaller batches.`;
            toast.error(errorMessage);
            console.error(errorMessage);
            return {
                success: false,
                count: 0
            };
        }
        
        // Import to Firestore with progress tracking
        let importedCount = 0;
        const batchSize = 50;
        
        for (let i = 0; i < allPuzzles.length; i += batchSize) {
            const batch = allPuzzles.slice(i, i + batchSize);
            const count = await bulkImportPuzzles(
                serviceProviderId,
                batch,
                userId
            );
            importedCount += count;
            
            // Report progress
            if (onProgress) {
                onProgress(Math.min(i + batchSize, allPuzzles.length), allPuzzles.length);
            }
        }
        
        console.log(`\n📊 FINAL IMPORT RESULTS:`);
        console.log(`   • Attempted to import: ${allPuzzles.length} puzzles`);
        console.log(`   • Actually imported: ${importedCount} puzzles`);
        console.log(`   • Duplicates/Skipped: ${allPuzzles.length - importedCount} puzzles`);
        
        if (importedCount > 0) {
            toast.success(`🎉 Successfully imported ${importedCount} advanced puzzles!`);
            console.log(`✅ Successfully imported ${importedCount} puzzles`);
        } else {
            toast.warning('⚠️ No new puzzles imported (all may already exist)');
            console.warn('⚠️ No new puzzles imported');
        }
        
        return {
            success: importedCount > 0,
            count: importedCount
        };
    } catch (error) {
        console.error('❌ Error seeding advanced puzzles:', error);
        toast.error('Failed to seed advanced puzzles to database');
        return {
            success: false,
            count: 0
        };
    }
};

/**
 * Check if puzzles already exist for a service provider
 */
export const checkPuzzlesExist = async (
    serviceProviderId: string,
    getPuzzlesForProvider: (id: string, filters?: any) => Promise<any[]>
): Promise<boolean> => {
    try {
        const existingPuzzles = await getPuzzlesForProvider(serviceProviderId, { limit: 1 });
        return existingPuzzles.length > 0;
    } catch (error) {
        console.error('Error checking existing puzzles:', error);
        return false;
    }
};
